import { useSelector } from "react-redux";
import { BrandImage } from "../../../../components/brandImage";
import { Link } from "react-router-dom";
import { FiSettings, FiMenu } from "react-icons/fi";
import "./style.css";
export const AdminBarMobile = ({ menuOpen = false, onMenuClick }) => {
  const info = useSelector(
    (state) => state.aplicationConfig.corporationData.info,
  );
  return (
    <header className="mobile adminBarMobile">
      <button
        type="button"
        className="adminMobileMenuButton"
        aria-label="Abrir menú de navegación"
        aria-controls="admin-sidebar"
        aria-expanded={menuOpen}
        onClick={onMenuClick}
      >
        <FiMenu aria-hidden="true" />
      </button>
      <div className="adminMobileBusiness">
        <BrandImage src={info?.logo} alt="Logotipo del negocio" />
        <span>
          <strong>{info?.corporation?.name || "Tu negocio"}</strong>
          <small>Panel de administración</small>
        </span>
      </div>
      <Link
        className="adminMobileSettings"
        to="/configuration"
        aria-label="Configuración del negocio"
      >
        <FiSettings aria-hidden="true" />
      </Link>
    </header>
  );
};
